// FlexibleRespiteCareSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import flexibleRespiteCareImage from '../assets/flexible-respite-care-image.jpg';

const FlexibleRespiteCareSection = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Content */}
          <div>
            <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Respite Care
            </p>
            <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Flexible Respite Care to Support Family Carers
            </h2>

            <div className="space-y-4 text-muted text-base leading-relaxed mb-10">
              <p>
                When someone you love needs care, it is natural to want to manage everything on your own. Yet balancing that responsibility with daily life can take a real toll, physically, mentally, and emotionally. We understand how demanding that can be.
              </p>

              <p>
                That is why Wei Care offers respite care, giving family carers a well-earned break to rest, recharge, and look after their own wellbeing. Whether you need a few hours or a few days, we are here to support you so you can keep caring with strength and peace of mind.
              </p>

              <p>
                With respite care, our trained, bonded, and insured carers step in to look after your loved one while you take time for yourself. Whether you want a quiet moment to rest, time with family, or a simple coffee with a friend, you can do so with confidence, knowing your loved one is in safe, respectful, and compassionate hands.
              </p>
            </div>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={18} />
              Call +61 420 162 243
            </a>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src={flexibleRespiteCareImage}
              alt="Hand holding a red heart"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlexibleRespiteCareSection;
